import { ColTypeDef, ICellEditorParams, ValueGetterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { IntlKey } from 'locales';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { Sales } from 'state/secondaryMarket/shared/referential/referential.model';
import { RowData, SecondaryBatchColumnDefinition } from 'state/workspaces/secondary-market/batch/model';

export function useStringArrayColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  const { formatMessage } = useSPIntl();

  return useMemo(
    () => ({
      cellEditor: 'agRichSelectCellEditor',
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const value = (colDef.field ? getValue(colDef.field) : undefined) as string | undefined;
        return value
          ? formatMessage({ id: `form.${colDef.field}.${value}` as IntlKey, defaultMessage: value }, undefined, {})
          : undefined;
      },
      valueFormatter: ({ value, colDef: { field } }) =>
        value
          ? formatMessage({ id: `form.${field}.${value}` as IntlKey, defaultMessage: value as string }, undefined, {})
          : '',
      cellEditorParams: {
        multiSelect: false,
        values: ({ colDef, data }: ICellEditorParams<RowData, Sales>) => {
          const { context } = colDef as SecondaryBatchColumnDefinition;
          const metadataId = colDef.context.metadataId;

          return metadataId ? (data.metadata[metadataId] ?? []) : (context.values ?? []);
        },
      },
      cellRenderer: LabelCellRenderer,
    }),
    [formatMessage],
  );
}
